import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { useChatContext } from '../../../../../contexts/ChatContext';
import { fetchContact } from '../../../../../utils/fetchContact';
import { Box, Typography } from '@coolblue-development/freddy';

const DigitalAssistentSummary = (): JSX.Element | null => {
  const { selectedChat } = useChatContext();
  const [summary, setSummary] = useState<string>('');

  useEffect(() => {
    if (!selectedChat) {
      setSummary('');
      return;
    }

    const contact = fetchContact(selectedChat);
    if (!contact) return;

    const chatbotSummary = contact.getAttributes().chatbot_summary?.value;

    setSummary(chatbotSummary ?? '');
  }, [selectedChat]);

  return summary ? (
    <>
      <Box
        data-testid="summary"
        sx={{
          width: '100%',
          border: '1px solid #DDDDDD',
          boxShadow: '0px 1px 2px 0px #285DAB33',
          padding: '16px',
          borderRadius: '5px'
        }}
      >
        <Typography variant="h2">Summary Digital Assistent</Typography>
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{summary}</ReactMarkdown>
      </Box>
    </>
  ) : null;
};

export default DigitalAssistentSummary;
